/* De sitepagina in het CRM (F9.12).
 *
 *   /crm/sites/:siteId   één Site, met daaronder het EMS
 *
 * Hangt in App.tsx BINNEN de /crm-route met CRMLayout, naast `sites` (de lijst),
 * dus met de gewone zijbalk en kop en achter dezelfde ProtectedRoute. Het pad is
 * daarom relatief. Lui geladen: het dashboard met three.js hoort niet in de
 * bundel van de lijst.
 */

import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

const SitePagina = lazy(() => import('./pages/SitePagina'));

export const SiteRoutes = (
  <Route path="sites/:siteId" element={
    <Suspense fallback={<div data-site-staat="laden" role="status" className="p-6 text-sm text-muted-foreground">Locatie laden…</div>}>
      <SitePagina />
    </Suspense>
  } />
);
